<template>
<div class="chapter">
<div class="inner_page">
<div id="tp">
<p class="tit">
<big>GHOST</big>
<br/> CHRONICLES<br/>
<br/>
<br/>
</p>
<p class="stit">
<big>TALES OF THE<br/> SUPERNATURAL</big>
<br/>
<br/>
<br/>
<br/>
<br/>
<br/>
<br/>
</p>
<p class="au">
<b>EDITED BY JOHN HARPER</b>
</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// HARP_9780715337851_epub_tp.vue?438538b5